export default "__VITE_ASSET__DgDrmpGl__"